export default ({ ambassadorIds }, data) => {
    return {
        liveEventId: data.id,
        ambassadorIds,
    }
}
